import { render, staticRenderFns } from "./NotificationExporter.vue?vue&type=template&id=a6c83a94"
import script from "./NotificationExporter.vue?vue&type=script&lang=js"
export * from "./NotificationExporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports